import { isDate } from 'lodash-es';

import { isDateString } from './is-date.js';
import { DateString } from '../types/dates.js';

/**
 *
 * @param input - A DateString
 * @returns a Unix timestamp in miliseconds
 */
export const convertDateStringToTimestamp = (input: DateString) =>
  new Date(input).getTime();

/**
 *
 * @param input - A Date
 * @returns a Unix timestamp in miliseconds
 */
export const convertDateToTimestamp = (input: Date) => input.getTime();

/**
 * Accepts any date format and transforms it into timestamp, making
 * it easier to handle in the charts with one single format.
 *
 * @param input - A DateString
 * @returns a Unix timestamp in miliseconds
 */
export const convertDateCompatibleToTimestamp = (
  input: number | DateString | Date,
) => {
  if (isDateString(input)) {
    return convertDateStringToTimestamp(input);
  }

  if (isDate(input)) {
    return convertDateToTimestamp(input);
  }

  return input;
};
